import React from "react";
import { Typography } from "@mui/material";
import { API_URL } from "./config";
import { useNavigate } from "react-router-dom";

const LogoutButton = ({ className, sx }) => {
    const navigate = useNavigate();

    const formDataObj = new FormData();
    formDataObj.append("action", "logout");

    const handleLogout = async () => {
        await fetch(API_URL + "auth.php", {
            method: "POST",
            body: formDataObj,
            credentials: "include",
        });

        navigate("/auth");
    };

    return (
        <Typography className={className} sx={sx} onClick={handleLogout}>
            Logout
        </Typography>
    );
};

export default LogoutButton;
